import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { uuid } from "common-frontend-components";
export const topPageId = 'TopPage-' + uuid();
export const TopPage = () => {
    return _jsx(Box, { sx: { width: 0, height: 0 }, id: topPageId }, void 0);
};
//# sourceMappingURL=TopPage.js.map